<template>
<div>
  <el-row type="flex" class="title-bar" justify="space-between">
    <el-radio-group v-model="tableType" class="mr-r10">
      <el-radio label="traffic">트래픽</el-radio>
      <el-radio label="error">트래픽 에러</el-radio>
    </el-radio-group>
    <w-header-search-button @click="onShowSearchToolButtonClick"></w-header-search-button>
  </el-row>
  <el-row>
    <!-- 현재(서버 요청 페이징, 검색) -->
    <el-table-wrapper v-loading="loading" v-show="(this.timeType === 'current' || operationFlag)" remote border :data="tableData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool"
    ref="tableCurrent" style="width:100%;" :show-overflow-tooltip="true" :pagination="true" @condition-change="loadData(true)" :total="total" :column-default="columnDefault">
      <template slot-scope="scope" slot="userateIn-slot">
        <el-progress v-if="scope.row['TRAFFIC/TRAFFIC_USERATE_IN'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['TRAFFIC/TRAFFIC_USERATE_IN'])"></el-progress>
        <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
      </template>
      <template slot-scope="scope" slot="userateOut-slot">
        <el-progress v-if="scope.row['TRAFFIC/TRAFFIC_USERATE_OUT'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['TRAFFIC/TRAFFIC_USERATE_OUT'])"></el-progress>
        <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
      </template>
      <template slot-scope="scope" slot="errorIn-slot">
        <el-progress v-if="scope.row['TRAFFIC_ERROR/TRAFFIC_ERROR_IN'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['TRAFFIC_ERROR/TRAFFIC_ERROR_IN'])"></el-progress>
        <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
      </template>
      <template slot-scope="scope" slot="errorOut-slot">
        <el-progress v-if="scope.row['TRAFFIC_ERROR/TRAFFIC_ERROR_OUT'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['TRAFFIC_ERROR/TRAFFIC_ERROR_OUT'])"></el-progress>
        <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
      </template>
      <template slot-scope="scope" slot="discardIn-slot">
        <el-progress v-if="scope.row['TRAFFIC_ERROR/TRAFFIC_DISCARD_IN'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['TRAFFIC_ERROR/TRAFFIC_DISCARD_IN'])"></el-progress>
        <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
      </template>
      <template slot-scope="scope" slot="discardOut-slot">
        <el-progress v-if="scope.row['TRAFFIC_ERROR/TRAFFIC_DISCARD_OUT'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['TRAFFIC_ERROR/TRAFFIC_DISCARD_OUT'])"></el-progress>
        <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
      </template>
      <template #interface-name-slot="scope">
        <span v-if="scope.row.objName" class="link c-pointer" @click="clickInterfaceName(scope.row)">{{scope.row.objName}}</span>
        <span v-else>-</span>
      </template>
    </el-table-wrapper>
  </el-row>
</div>
</template>
<script>
import { isNil, floor, cloneDeep, isEmpty } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit, convertValueForInterfaceSpeed } from '@/utils/number';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { analysisTimeType, performanceNodeTabs } from '@/constants/performance';
import netdeviceTableInfoAPI from '@/api/performance/netdevice/netdevice-table-info';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
// const netinterfaceStatusOperFilters = [{ text: 'UP', value: '1' }, { text: 'DOWN', value: '2' }];
// const netinterfaceStatusAdminFilters = [{ text: 'UP', value: '1' }, { text: 'DOWN', value: '0' }];
// const netinterfaceDuplexFilters = [{ text: 'FULL', value: 'FULL' }, { text: 'AUTO', value: 'AUTO' }, { text: 'HALF', value: 'HALF' }];

export default {
  name: 'WOperationInterfaceTable',
  mixins: [analysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      loading: false,
      tableType: 'traffic',
      tableData: [],
      checkDatetime: null,
      columnDefault,
      columns: [],
      total: null,
      defaultTableColumns: [
        { prop: 'parentObjName', label: '장비명', headerAlign: 'center', formatter: this.getParentObjName },
        { prop: 'netinterfaceStatusOper', label: 'Oper 상태', headerAlign: 'center', sortable: true, width: 80, formatter: this.getStateOperString, remoteProp: 'ni.netinterface_status_oper', sortProp: 'o.netinterfaceStatusOper' },
        { prop: 'netinterfaceStatusAdmin', label: 'Admin 상태', headerAlign: 'center', sortable: true, width: 90, formatter: this.getStateAdminString, remoteProp: 'ni.netinterface_status_admin', sortProp: 'o.netinterfaceStatusAdmin' },
        { prop: 'netinterfaceIfindex', label: '인덱스', width: 65, sortable: true, searchable: true, remoteProp: 'ni.netinterface_ifindex', sortProp: 'o.netinterfaceIfindex' },
        { prop: 'objName', label: '인터페이스명', headerAlign: 'center', width: 100, sortable: true, searchable: true, scopedSlot: 'interface-name-slot', remoteProp: 'ni.netinterface_name', sortProp: 'o.objName' },
        { prop: 'netinterfaceAlias', label: '별칭', headerAlign: 'center', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty, remoteProp: 'ni.netinterface_alias', sortProp: 'o.netinterfaceAlias' },
        { prop: 'netinterfaceSpeed', label: '대역폭', width: 80, headerAlign: 'center', sortable: true, formatter: this.convertNetinterfaceSpeed, remoteProp: 'ni.netinterface_speed', sortProp: 'o.netinterfaceSpeed' },
        { prop: 'netinterfaceDuplex', label: 'Duplex', width: 80, headerAlign: 'center', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty, remoteProp: 'ni.netinterface_duplex', sortProp: 'o.netinterfaceDuplex' },
      ],
      trafficColumns: [
        { label: 'bps',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'TRAFFIC/TRAFFIC_BPS_IN',
              label: 'IN',
              headerAlign: 'center',
              formatter: this.convertBpsValue,
              width: 80,
              sortable: true,
            },
            {
              prop: 'TRAFFIC/TRAFFIC_BPS_OUT',
              label: 'OUT',
              headerAlign: 'center',
              formatter: this.convertBpsValue,
              width: 80,
              sortable: true,
            },
          ],
        },
        { label: 'pps',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'TRAFFIC/TRAFFIC_PPS_IN',
              label: 'IN',
              headerAlign: 'center',
              formatter: this.convertPpsValue,
              width: 80,
              sortable: true,
            },
            {
              prop: 'TRAFFIC/TRAFFIC_PPS_OUT',
              label: 'OUT',
              headerAlign: 'center',
              formatter: this.convertPpsValue,
              width: 80,
              sortable: true,
            },
          ],
        },
        { label: '이용률',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'TRAFFIC/TRAFFIC_USERATE_IN',
              label: 'IN',
              align: 'center',
              scopedSlot: 'userateIn-slot',
              width: 100,
              sortable: true,
            },
            {
              prop: 'TRAFFIC/TRAFFIC_USERATE_OUT',
              label: 'OUT',
              align: 'center',
              scopedSlot: 'userateOut-slot',
              width: 100,
              sortable: true,
            },
          ],
        },
      ],
      errorColumns: [
        { prop: 'TRAFFIC_ERROR/TRAFFIC_CRC_IN', label: 'CRC', width: 60 },
        { prop: 'TRAFFIC_ERROR/TRAFFIC_COLLISION_OUT', label: 'COLLISION', width: 90 },
        { label: '에러율(Error)',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'TRAFFIC_ERROR/TRAFFIC_ERROR_IN',
              label: 'IN',
              align: 'center',
              scopedSlot: 'errorIn-slot',
              width: 100,
              sortable: true,
            },
            {
              prop: 'TRAFFIC_ERROR/TRAFFIC_ERROR_OUT',
              label: 'OUT',
              align: 'center',
              scopedSlot: 'errorOut-slot',
              width: 100,
              sortable: true,
            },
          ],
        },
        { label: '기각률(Discard)',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'TRAFFIC_ERROR/TRAFFIC_DISCARD_IN',
              label: 'IN',
              align: 'center',
              scopedSlot: 'errorIn-slot',
              width: 100,
              sortable: true,
            },
            {
              prop: 'TRAFFIC_ERROR/TRAFFIC_DISCARD_OUT',
              label: 'OUT',
              align: 'center',
              scopedSlot: 'errorOut-slot',
              width: 100,
              sortable: true,
            },
          ],
        },
        { label: 'Drop',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'TRAFFIC_ERROR/TRAFFIC_DROP_IN',
              label: 'IN',
              align: 'center',
              scopedSlot: 'errorIn-slot',
              width: 100,
              sortable: true,
            },
            {
              prop: 'TRAFFIC_ERROR/TRAFFIC_DROP_OUT',
              label: 'OUT',
              align: 'center',
              scopedSlot: 'errorOut-slot',
              width: 100,
              sortable: true,
            },
          ],
        },
      ],
      showSearchTool: false,
    };
  },
  watch: {
    tableType() {
      this.loadData(false, true);
    },
  },
  methods: {
    /**
     * 인터페이스 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData(conditionChangeFlag, filterFlag) {
      if (!this.active) {
        return;
      }
      if (filterFlag) {
        this.$refs.tableCurrent.clearFilter();
      }
      if (!conditionChangeFlag) {
        // 초기화
        this.columns = [];
      }
      this.$nextTick(() => {
        if (!conditionChangeFlag) {
          this.setTableColumns();
        }
        const params = {
          objId: this.selectedNode.obj.objId,
          managetypeId: 'NMS',
        };
        if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
          params.baselineDatetime = this.plotLineDatetime;
          this.loading = true;
          netdeviceTableInfoAPI.getInterfaceList(params).then((response) => {
            if (response.data.success === true) {
              const snapshotData = response.data.data;
              this.tableData = snapshotData.snapshotDoc;
              this.checkDatetime = snapshotData.timestamp;
            } else {
              this.failToLoad();
            }
          }).catch(() => {
            this.failToLoad();
          }).finally(() => {
            this.loading = false;
          });
        } else {
          this.loading = true;
          if (!conditionChangeFlag) {
            this.$refs.tableCurrent.clearFilter();
          }
          const searchParams = this.$refs.tableCurrent.getParameter();
          const targetParams = {
            ...params,
            ...searchParams,
          };
          netdeviceTableInfoAPI.getCurrentInterfaceList(targetParams).then((response) => {
            if (response.data.success === true) {
              this.tableData = response.data.data;
              this.total = response.data.total;
            } else {
              this.failToLoad();
            }
          }).catch(() => {
            this.failToLoad();
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '인터페이스', false));
    },
    onShowSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    setTableColumns() {
      const defulatTableColumns = cloneDeep(this.defaultTableColumns);
      this.columns = this.tableType === 'traffic' ? defulatTableColumns.concat(this.trafficColumns) : defulatTableColumns.concat(this.errorColumns);

      // L4장비인 경우 Hit Count 컬럼을 추가로 제공한다.
      if (this.selectedNode.obj.objtypeId === 'L4SW' && this.tableType === 'traffic') {
        this.columns.push(
          { label: 'Hit Count',
            headerAlign: 'center',
            childColumns: [
              {
                prop: '',
                label: 'Tx',
                sortable: true,
                headerAlign: 'center',
                formatter: this.getTableValueAfterCheckEmpty,
                width: 80,
              },
              {
                prop: '',
                label: 'Rx',
                sortable: true,
                headerAlign: 'center',
                formatter: this.getTableValueAfterCheckEmpty,
                width: 80,
              },
            ],
          });
      }
    },
    /**
     * [getStateString 그리드 컬럼 설정]
     * @author {Yang}
     */
    getStateOperString(row) {
      if (row.netinterfaceStatusOper === '1' || row.netinterfaceStatusOper === 1) {
        return 'UP';
      }
      return 'DOWN';
    },
    getStateAdminString(row) {
      if (row.netinterfaceStatusAdmin === '1' || row.netinterfaceStatusAdmin === 1) {
        return 'UP';
      }
      return 'DOWN';
    },
    getParentObjName(row, column, value) {
      if (isNil(value)) {
        const selectedNode = this.$store.getters.selectedNode;
        const parentObjName = selectedNode.obj.objName;
        return parentObjName;
      }
      return this.getTableValueAfterCheckEmpty(null, null, value);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * bps 데이터 단위 변환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertBpsValue(row, column, value) {
      return convertValuByUnit(value, 'bps', true, true, true);
    },
    /**
     * pps 데이터 단위 변환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertPpsValue(row, column, value) {
      return convertValuByUnit(value, 'pps', true, true, true);
    },
    /**
     * 대여폭 단위 변환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertNetinterfaceSpeed(row, column, value) {
      return convertValueForInterfaceSpeed(value);
    },
    /**
     * [filterNetinterfaceStatusOper 테이블 search 필터]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @param  {[type]} row   [description]
     * @return {[type]}       [description]
     */
    filterNetinterfaceStatusOper(value, row) {
      if (row.netinterfaceStatusOper === '1') {
        return row.netinterfaceStatusOper === value;
      }
      return row.netinterfaceStatusOper !== '1';
    },
    filterNetinterfaceStatusAdmin(value, row) {
      if (row.netinterfaceStatusAdmin === '1') {
        return row.netinterfaceStatusAdmin === value;
      }
      return row.netinterfaceStatusAdmin !== '1';
    },
    filterNetinterfaceDuplex(value, row) {
      return row.netinterfaceDuplex === value;
    },
    /**
     * [getPercentage 프로그래스바 * 100]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getPercentage(value) {
      return isNil(value) ? 0 : floor(value, 2);
    },
    /**
     * 인터페이스명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickInterfaceName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
    // 오버라이딩
    onCurrentDataReLoad() {
      this.loadData(true);
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/table/OperationInterfaceTable.vue